import { BaseEditViewStore } from 'core/stores';
import { FacilityOrderTemplateMissingDocumentNoteModalForm } from '../../facility-order/forms';
import { NikoPatientTemplateService } from '../services';
import { action } from "mobx";

class NikoTemplateMissingDocumentNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const patientTemplateService = new NikoPatientTemplateService(rootStore.application.baasic.apiClient);
        const patientTemplateMissingDocument = componentProps.modalParams.data.patientTemplateMissingDocument;
        super(rootStore, {
            name: 'missing-document-note-modal',
            id: patientTemplateMissingDocument.patientTemplateId,
            actions: () => {
                return {
                    get: async () => {
                        patientTemplateMissingDocument.note = patientTemplateMissingDocument.note || '';
                        patientTemplateMissingDocument.isPreviousDos = patientTemplateMissingDocument.isPreviousDos || false;
                        return patientTemplateMissingDocument;
                    },
                    update: async (resource) => {
                        if (componentProps.modalParams.data.setNote) {
                            patientTemplateMissingDocument.note = resource.note;
                            patientTemplateMissingDocument.isPreviousDos = resource.isPreviousDos;
                            this.modalParams.close();
                        }
                        else {
                            const response = await patientTemplateService.updateMissingDocumentNote({ id: patientTemplateMissingDocument.id, note: resource.note, isPreviousDos: resource.isPreviousDos });
                            if(this.modalParams.data.updateMissingDocNote){
                                this.modalParams.data.updateMissingDocNote(patientTemplateMissingDocument.id, resource.note, resource.isPreviousDos);
                            }
                            this.modalParams.close();
                            return response.data;
                        }

                    }
                }
            },
            FormClass: FacilityOrderTemplateMissingDocumentNoteModalForm,
            shouldGoBackAfterAction: false
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.patientTemplateMissingDocument = patientTemplateMissingDocument;
    }

    @action.bound
    notifySuccessUpdate() {
        this.rootStore.notificationStore.success('Missing Document Note successfully updated.');
    }
}

export default NikoTemplateMissingDocumentNoteModalStore;
